export default () => (
  /**
   * Icone de uma lixeira.
   * Responsável por apagar camadas importadas.
   * Encontrado no menu de ações das camadas importadas.
   */
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.72461 1.5293H4.09961V1.1543C4.09961 0.809119 4.37943 0.529297 4.72461 0.529297H6.72461C7.06979 0.529297 7.34961 0.809119 7.34961 1.1543V1.5293H7.72461H10.2246C10.2936 1.5293 10.3496 1.58526 10.3496 1.6543V2.6543C10.3496 2.72333 10.2936 2.7793 10.2246 2.7793H9.72461H9.34961V3.1543V10.1543C9.34961 10.4995 9.06979 10.7793 8.72461 10.7793H2.72461C2.37943 10.7793 2.09961 10.4995 2.09961 10.1543V3.1543V2.7793H1.72461H1.22461C1.15557 2.7793 1.09961 2.72333 1.09961 2.6543V1.6543C1.09961 1.58526 1.15557 1.5293 1.22461 1.5293H3.72461ZM4.22461 3.7793C3.74136 3.7793 3.34961 4.17105 3.34961 4.6543V8.6543C3.34961 9.13755 3.74136 9.5293 4.22461 9.5293C4.70786 9.5293 5.09961 9.13755 5.09961 8.6543V4.6543C5.09961 4.17105 4.70786 3.7793 4.22461 3.7793ZM7.22461 3.7793C6.74136 3.7793 6.34961 4.17105 6.34961 4.6543V8.6543C6.34961 9.13755 6.74136 9.5293 7.22461 9.5293C7.70786 9.5293 8.09961 9.13755 8.09961 8.6543V4.6543C8.09961 4.17105 7.70786 3.7793 7.22461 3.7793Z"
      stroke="#7B8084"
      strokeWidth="0.75"
    />
  </svg>
);
